import parse from "html-react-parser";

const regexpForEmails = /<([\s\S]+?)>/g;

export const createEmailsField = (emails, change = false) => {
  const array = emails.split(",");
  const numberOfEmails = array?.length;
  const firstElement = array[0];
  const emailLength = 30;

  const firstEmail = regexpForEmails.test(firstElement)
    ? firstElement.match(regexpForEmails)[0]?.replace(/[<>]/g, "")
    : firstElement;

  const email =
    firstEmail?.length >= emailLength
      ? firstEmail.slice(0, emailLength) + "..."
      : firstEmail;

  const elementStyle = "margin-left: 0.375rem; color: #9f9f9f;";

  if (numberOfEmails > 1) {
    return change
      ? parse(
          `${email} <span style='${elementStyle}'>+${numberOfEmails - 1}</span>`
        )
      : `${email} <span style='${elementStyle}'>+${numberOfEmails - 1}</span>`;
  } else {
    return email;
  }
};

export const removeUnnecessaryData = (emails) => {
  const array = emails?.split(",");
  const newArray = array?.map((item) => {
    return item?.match(regexpForEmails) !== null
      ? item?.match(regexpForEmails)[0]?.replace(/[<>]/g, "")
      : item;
  });

  return newArray?.join(", ");
};

const eventTimestamp = (item) =>
  item?.call_date_time ??
  item?.sent_date ??
  item?.["Clock In"] ??
  item?.["Clock Out"] ??
  item?.["Scheduled In"] ??
  item?.["Scheduled Out"];

export const sortAscending = (result) => {
  return result.sort(
    (a, b) => new Date(eventTimestamp(a)).getTime() - new Date(eventTimestamp(b)).getTime(),
  );
};

export const sortDescending = (result) => {
  return result.sort(
    (a, b) => new Date(eventTimestamp(b)).getTime() - new Date(eventTimestamp(a)).getTime(),
  );
};
